import { useRef } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { PrefillResumeEvents } from 'builder/modules/constants'
import { useI18n } from 'builder/hooks/useI18n'
import uploadResumeImage from '../assets/upload-resume.svg'
import FileSelector from '../../UploadResume/FileSelector/FileSelector'
import {
  Card,
  CardTitleWrapper,
  CardTitle,
  ImageWrapper,
  Image,
  IconWrapper,
  ArrowIcon,
} from './styles'

export const UploadResume = () => {
  const { i18n } = useI18n()
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleCardClick = () => {
    trackInternalEvent(PrefillResumeEvents.clickUploadResume)
    fileInputRef.current?.click()
  }

  return (
    <Card onClick={handleCardClick}>
      <ImageWrapper>
        <Image src={uploadResumeImage} alt="Upload Resume" />
      </ImageWrapper>
      <CardTitleWrapper>
        <CardTitle>{i18n.t('builder.prefill_resume.upload_resume')}</CardTitle>
      </CardTitleWrapper>
      <IconWrapper>
        <ArrowIcon />
      </IconWrapper>
      <FileSelector ref={fileInputRef} />
    </Card>
  )
}
